import { dispatch } from 'store'
import {
  AIVideoSocketMessageState,
  AIVideoSocketMessageStatus,
  IAIVideoSocketMessage
} from 'types/aiVideo'
import { aiVideoSocketHandlers } from './socketHandlers'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { TAppDispatch, TGetState } from 'store/types'

export const handleAiVideoSocketData = (data: IAIVideoSocketMessage) => {
  if (data.state) {
    switch (data.state) {
      case AIVideoSocketMessageState.ERROR: {
        dispatch(aiVideoSocketHandlers.processFailedAIVideo(data))
        dispatch(aiLibThunks.setIsLoaded(false))
        break
      }
    }
  }
  if (data.status) {
    switch (data.status) {
      case AIVideoSocketMessageStatus.COMPLETED:
        dispatch(aiVideoSocketHandlers.processCompletedAIVideo(data))
        dispatch(aiLibThunks.setIsLoaded(false))
        break

      case AIVideoSocketMessageStatus.FAILED:
        dispatch(aiVideoSocketHandlers.processFailedAIVideo(data))
        dispatch(aiLibThunks.setIsLoaded(false))
        break

      case AIVideoSocketMessageStatus.PROCESSING:
        dispatch(aiVideoSocketHandlers.updateProcessingAIVideo(data))
        break
    }
  }
}

const updatePendingAiVideosPerPastSocketData =
  (data: IAIVideoSocketMessage) => (_: TAppDispatch, getState: TGetState) => {
    const state = getState()
    const pendingAIVideoMediaItems =
      projectDataSelectors.pendingAIVideoMediaItems(state)
    if (!pendingAIVideoMediaItems.length) return

    const isDataForPendingItem = pendingAIVideoMediaItems.some(
      pendingItem =>
        pendingItem.assetId === data.gen_ai_video_hash ||
        pendingItem.assetId === String(data.id)
    )
    if (isDataForPendingItem) {
      handleAiVideoSocketData(data)
    }
  }

export const handleAiVideoPastSocketData = (data: IAIVideoSocketMessage) => {
  if ('gen_ai_video_hash' in data) {
    dispatch(updatePendingAiVideosPerPastSocketData(data))
  }
}
